import { useBankingAuthQuery } from "Api/Mutations/useBankingAuth";

export const useBankingAuth = () => {
  const { mutate, isPending, variables } = useBankingAuthQuery({
    onSuccess: ({ url }) => {
      // CZKT has no browser redirect — account is created server-side.
      // Redirect to our backend callback endpoint to complete the token exchange.
      if (url.startsWith("czkt://")) {
        const state = new URL(url).searchParams.get("state");
        window.location.href = `${import.meta.env.VITE_API_URL}/api/banking/auth/callback?state=${encodeURIComponent(state ?? "")}`;
      } else {
        window.location.href = url;
      }
    },
  });

  return {
    authorize: mutate,
    isPending,
    selectedEnvironment: variables?.environment,
  };
};
